import { useEffect, useRef, useState } from 'react';
import style from '../ui/modals/modals.module.scss';
import { getText } from '../../i18n';

const ContactUs = () => {
    const footerRef = useRef(null);
    const email = 'app-support@ingaged.me';

    useEffect(() => {
        if (footerRef.current) {
            const buttons = footerRef.current.querySelectorAll('.btn');
            let maxWidth = 0;

            buttons.forEach(button => {
                maxWidth = Math.max(maxWidth, button.offsetWidth);
            });

            buttons.forEach(button => {
                button.style.width = `${maxWidth}px`;
            });
        }
    }, []);

    return (
        <div className={`modal-body text-center ${style.modalBody}`}>
            <i
                className="bi bi-envelope-open primary-blue-color"
                style={{ fontSize: '60px', paddingBottom: '24px' }}
            />
            <div style={{ fontSize: '20px' }}>{getText('msg_6dca09e9607b')}</div>
            <div style={{ lineHeight: '20px', paddingBottom: '24px' }}>
                <i
                    className="bi bi-envelope"
                    style={{ fontSize: '16px', paddingRight: '8px' }}
                />
                <a href={'mailto:' + email} style={{ fontSize: '14px' }}>
                    {email}
                </a>
            </div>
            <div style={{ color: 'rgb(102, 112, 133)' }}>
                <div>
                    {getText('msg_a2d9584089cf')}
                </div>
                <div>
                    <ul
                        style={{
                            listStyleType: 'disc',
                            display: 'inline-block',
                            textAlign: 'left',
                        }}
                    >
                        <li>{getText('msg_01b91336a118')}</li>
                        <li>{getText('msg_133160594d08')}</li>
                        <li>{getText('msg_8599f5cc48ff')}</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
